export const globalRowWrapperPadding = {
  xSmallUp: "0px 16px 32px",
  smallUp: "16px 40px 32px",
};

export const globalRowCardMargin = {
  gridGap: "16px",
};
